import { ZustandStateGate } from "./gate/ZustandStateGate";

import { useOneFrontStore, OneFrontStore } from "./store/onefront-store";
export { useStateSession } from "./hooks/useStateSession";
export { useStateStorage } from "./hooks/useStateStorage";

export { useOneFrontStore };

export const serviceState = () => {
  return [
    {
      target: "$ONE_LAYOUT_ROUTES_BEFORE",
      handler: { component: ZustandStateGate }
    },
    {
      target: "$ONE_AUTH_ON_LOGOUT",
      handler: {
        onLogout: () => {
          const { getState } = OneFrontStore;
          const { clearAll } = getState((state) => state.clearAll);

          clearAll();
        }
      }
    }
  ];
};
